import { useEffect } from "react";
import { LayoutProps, TErrorFallback } from "@ts/common-types";
import ErrorHandler from "./ErrorHandler";
import * as Sentry from "@sentry/react";

const ErrorFallback: React.FC<TErrorFallback> = ({
    error
}) => {
    
    useEffect(() => {
        console.error(`[TabsErrorComponent] ${error}`);
        Sentry.captureException(error);
    }, [error]);

    return (<></>);
};

const TabsErrorComponent: React.FC<LayoutProps> = (props) => {
    return (
        <ErrorHandler FallbackComponent={ErrorFallback}>
            {props.children}
        </ErrorHandler>
    );
};

export default TabsErrorComponent;
